/**
 * ============================================================
 * Highlight Engine
 * MiningSurveyWebGIS
 * ============================================================
 */

import Geometry from "./geometry.js";

class Highlight {
    /**
     * Highlight Feature
     */
    highlight(feature) {
        const layer = feature.layer;

        if (!layer) return;

        // Polyline / Polygon
        if (layer.setStyle) {
            Geometry.saveOriginalStyle(layer);

            const s = layer._originalStyle;

            layer.setStyle({
                color: s.color,

                weight: Math.max((s.weight || 2) * 4, (s.weight || 2) + 2),

                opacity: 1,

                fillColor: s.fillColor,

                fillOpacity: s.fillOpacity,
            });

            if (layer.bringToFront) {
                layer.bringToFront();
            }
        }

        // Marker
        if (layer.setZIndexOffset) {
            layer.setZIndexOffset(1000);
        }
    }

    /**
     * Restore Original Style
     */
    restore(feature) {
        if (!feature) return;

        const layer = feature.layer;

        if (!layer) return;

        Geometry.restoreOriginalStyle(layer);

        if (layer.setZIndexOffset) {
            layer.setZIndexOffset(0);
        }
    }

    /**
     * Toggle
     */
    toggle(feature) {
        if (!feature) return;

        if (feature.highlighted) {
            this.restore(feature);

            feature.highlighted = false;
        } else {
            this.highlight(feature);

            feature.highlighted = true;
        }
    }
}

export default new Highlight();
